export default {
    /** 成功 */
    SUCC: 0,
    /** 失败 */
    FAIL:-1,
    /** 未登录，token已失效 */
    UNAUTHEN: 1000,
    /** 未登录，客户不存在 */
    UNLOGIN: 3000
  }